var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRunIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    clipPath: "url(#clip0_1876_194951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.2555 4.99279C21.4894 4.99279 22.4896 4.01459 22.4896 2.80792C22.4896 1.60125 21.4894 0.623047 20.2555 0.623047C19.0217 0.623047 18.0215 1.60125 18.0215 2.80792C18.0215 4.01459 19.0217 4.99279 20.2555 4.99279Z",
    fill: "#538FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.7504 4.90336L22.1492 8.75135L21.9325 8.97962C21.2239 9.74595 20.0069 9.79487 19.2316 9.1019H19.2233L18.8398 8.74319L20.2736 7.21867L20.3487 7.13715C20.4404 7.21867 20.5654 7.26759 20.7071 7.26759C20.8488 7.26759 20.9739 7.21867 21.0656 7.13715C21.0822 7.12084 24.3333 3.63972 24.3333 3.63972C24.6917 3.25656 25.3002 3.2321 25.692 3.5745C26.0838 3.92506 26.1088 4.52019 25.7504 4.90336Z",
    fill: "#538FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.9546 11.938L7.57783 17.6855C7.21938 18.0687 6.61919 18.0931 6.2274 17.7426C5.83561 17.392 5.8106 16.7969 6.16905 16.4137L11.8125 10.3809C11.8292 10.7233 11.9792 11.0575 12.2627 11.3021L12.9629 11.9298L12.9546 11.938Z",
    fill: "#538FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19.0081 6.07283L18.1912 5.3391L17.1658 4.42602L17.0908 4.3608L15.4736 2.91781C15.1402 2.61616 14.6484 2.53464 14.2316 2.69769L12.6811 3.31728L9.59674 4.54831C9.10491 4.74397 8.87151 5.29019 9.07157 5.77118C9.27163 6.25218 9.83015 6.48045 10.322 6.28479L13.9231 4.8418C14.0898 4.77658 14.2899 4.80919 14.4233 4.93148L15.5903 5.975L12.631 9.14632C12.1059 9.70885 12.1476 10.5812 12.7227 11.0948L13.5063 11.7959L15.2902 13.3938C15.682 13.7443 15.707 14.3313 15.3486 14.7063L12.3976 17.8695C12.0392 18.2527 12.0642 18.8478 12.456 19.1902C12.8478 19.5408 13.4563 19.5163 13.8064 19.1331L17.616 15.0569C18.3329 14.2906 18.2745 13.1084 17.4993 12.4073L15.9821 11.0459L19.0998 7.71148C19.5416 7.23864 19.5082 6.51306 19.0248 6.08098L19.0081 6.07283Z",
    fill: "#538FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.4769 2.54688H3.36725C3.04037 2.54688 2.77539 2.8042 2.77539 3.12163C2.77539 3.43905 3.04037 3.69638 3.36725 3.69638H7.4769C7.80377 3.69638 8.06875 3.43905 8.06875 3.12163C8.06875 2.8042 7.80377 2.54688 7.4769 2.54688Z",
    fill: "#538FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6.09408 9.46875H1.98443C1.65756 9.46875 1.39258 9.72608 1.39258 10.0435C1.39258 10.3609 1.65756 10.6183 1.98443 10.6183H6.09408C6.42096 10.6183 6.68594 10.3609 6.68594 10.0435C6.68594 9.72608 6.42096 9.46875 6.09408 9.46875Z",
    fill: "#538FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M7.4774 5.88086H0.591856C0.264983 5.88086 0 6.13818 0 6.45561C0 6.77304 0.264983 7.03036 0.591856 7.03036H7.4774C7.80427 7.03036 8.06925 6.77304 8.06925 6.45561C8.06925 6.13818 7.80427 5.88086 7.4774 5.88086Z",
    fill: "#538FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1876_194951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 18.922,
    fill: "white",
    transform: "translate(0 0.623047)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunIcon);
export default __webpack_public_path__ + "static/media/RunIcon.f155d84a.svg";
export { ForwardRef as ReactComponent };